<template>
  <div>
    <h1><img src="../assets/main.png" alt="TITLE" /></h1>
    <div class="white-area">
      <p class="thank">応募受付は終了いたしました</p>
      <p class="text--bold">
        「ENERYGY CHARGE LIVE(仮) feat.
        ナオト・インティライミ」の応募受付は終了いたしました。
        たくさんのご応募ありがとうございました。
      </p>
      <p class="text--midium">
        厳選な抽選のうえ、当選された⽅には3⽉中に充レン公式LINEアカウントからLINEメッセージでお知らせいたします。<br />なお、充レン公式LINEアカウントの友だち登録を解除されますと当選無効になりますのでご注意ください。
      </p>
      <a class="event-link" href="">イベントの詳細はこちら</a>
    </div>

    <div class="coupon" v-if="couponCode !== ''">
      <div class="bold">
        <p class="coupon__text--top center">
          ご応募いただいた⽅だけにスペシャルプレゼント
        </p>
        <p class="coupon__text--big color-orange center">
          モバイルバッテリーレンタルサービス<br />「充レン」<br /><strong
            >無料クーポン</strong
          >
        </p>
        <p class="coupon__text--middle">
          「充レン」を借りた⽇の翌⽇24時まで1回無料でご利⽤いただけます（税込330円相当）。
        </p>
      </div>
      <div class="number-area bold">
        <p class="area__title color-orange center">クーポン番号</p>
        <div
          class="area__number center"
          v-clipboard:copy="couponCode"
          v-clipboard:success="onCopy"
        >
          <p id="tapCopy">{{ couponCode }}</p>
        </div>
        <p class="area__text--small color-orange center">
          番号をタップしてコピーできます。
        </p>
        <p class="area__text--midium">
          「充レン」をレンタルする際、レンタル情報確認画⾯で「クーポンを利⽤する」を選択して、クーポン番号を⼊⼒してください。
        </p>
        <p class="area__text--limlt bg-color1 center">
          クーポン有効期限:<br />2020年4⽉30⽇ 23時59分まで
        </p>
      </div>
      <p class="coupon__text--alert">
        ※1度ご利⽤いただいた後のクーポンは再利⽤できません<br />
        ※クーポンはご応募頂いたご本⼈様のみご利⽤可能です。第三者への譲渡はできません。<br />
        ※クーポンの現⾦化はできません。
      </p>
    </div>

    <footer>
      <div class="bg-black">
        <h3>お問い合わせ先</h3>
        <p class="footer__text--midium">《充レンサポートセンター》</p>
        <p class="footer__text--small">
          充レン公式LINEアカウントのメニューから、「Q&A・お問い合わせ」→「その他のお問い合わせ」→「トラブル等」を選択いただき、オペレーターをお呼び出しください。
        </p>
      </div>
      <div class="bg-gray">
        <p>(c) TEPCO Energy Partner, Inc.</p>
      </div>
    </footer>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  computed: {
    ...mapGetters(["couponCode"])
  },
  methods: {
    onCopy: () => {
      alert("コピーしました！");
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/ClosedRegistration.vue